import { create } from 'zustand'

import { Capacitor } from '@capacitor/core'
import { Browser } from '@capacitor/browser'

import googleDriveAPI from '@/services/api/googleDrive'
import { useUserStore } from '@/store/useUserStore'

export type DriveSheet = 'connect' | 'manage' | null

interface DriveStore {
  activeSheet: DriveSheet
  isConnecting: boolean
  failed: boolean

  openSheet: () => void
  closeSheet: () => void
  connect: () => Promise<void>
  disconnect: () => Promise<void>
}

export const useDriveStore = create<DriveStore>((set) => ({
  activeSheet: null,
  isConnecting: false,
  failed: false,

  openSheet: () => set({
    activeSheet: useUserStore.getState().user?.google_drive_connection?.status === 'connected' ? 'manage' : 'connect',
    failed: false,
  }),
  closeSheet: () => set({ activeSheet: null }),

  connect: async () => {
    set({ isConnecting: true, failed: false })

    try {
      const { authorization_url } = await googleDriveAPI.createConnection()

      if (Capacitor.isNativePlatform()) {
        await Browser.open({ url: authorization_url })
        set({ isConnecting: false, activeSheet: null })
      } else {
        window.location.href = authorization_url
      }
    } catch {
      set({ isConnecting: false, failed: true })
    }
  },

  disconnect: async () => {
    set({ activeSheet: null })

    try {
      await googleDriveAPI.destroyConnection()
      await useUserStore.getState().sync()
    } catch {
      set({ failed: true })
    }
  },
}))
